let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("6vzdH"), load("lRtGG"), load("ffEVr"), load("kjZZD"), load("aGZFn"), load("7Xau5")]).then(() => parcelRequire('aUago'));